import { Box } from '@mui/material';
import MessageInput from './MessageInput';
import MessageList from './MessageList';

export default function ChatConversation({ messages, isTyping, onSend,  onEdit, onDelete, variant = 'full' }) {
  const isEmbedded = variant === 'embedded';
  const isEmpty = messages.length === 0;
  return (
    <Box
      sx={{
        minHeight: variant === 'embedded' ? 'auto' : '60vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start'
      }}
    >
      {/* Messages */}
      {!isEmpty && (
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            pb: '96px'
          }}
        >
          <Box sx={{ maxWidth: 995, mx: 'auto', px: 3 }}>
            <MessageList messages={messages} isTyping={isTyping} onEdit={onEdit} onDelete={onDelete} />
          </Box>
        </Box>
      )}

      {/* Sticky input */}
      <Box
        sx={{
          position: isEmpty ? 'relative' : 'sticky',
          bottom: 0,
          background: 'background.default'
        }}
      >
        <Box sx={{ maxWidth: isEmbedded ? 880 : 990, mx: 'auto', px: isEmbedded ? 0 : 3, py: 2 }}>
          <MessageInput onSend={onSend} />
        </Box>
      </Box>
    </Box>
  );
}
